

const Open_nav_reducer=(state ="close", action)=>{
  switch (action.type) {
    case "open":
      return "open";
    case "close":
      return "close";
    default:
      return state;
  }
}

export default Open_nav_reducer;